@import '../../constants/spacing.module.less';

.character-count {
  font-size: 12px;
  line-height: 18px;
  color: var(--default--text-color--15);
}

.remaining-count {
  margin-left: @space-4;
  font-weight: 500;
  color: var(--default--text-color--16);
}

.read-only-message {
  font-size: 12px;
  line-height: 1.2;

  .button {
    font-size: 12px;
  }
}
